"use client";

export default function AboutPage() {
  return (
    <main className="max-w-4xl mx-auto p-6 space-y-10">
      <h1 className="text-3xl font-bold text-amber-400 uppercase mb-6">
        ABOUT US
      </h1>

      <section>
        <h2 className="text-xl font-semibold text-amber-400 uppercase mb-2">
          OUR MISSION
        </h2>
        <p className="text-gray-300">
          We exist to help people grow. Whether you're an aspiring pilot, a seasoned professional, or an
          organisation developing future leaders, we believe mentoring is the key to unlocking potential.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold text-amber-400 uppercase mb-2">
          OUR STORY
        </h2>
        <p className="text-gray-300">
          Flightpath Mentoring was born from aviation - an industry where effective leadership is the difference
          between success and failure. The same principles that keep flight crews effective and safe apply directly
          to modern organisations.
        </p>
      </section>

      <section className="flex flex-col md:flex-row md:items-start gap-6">
        <div className="flex-1">
          <h2 className="text-xl font-semibold text-amber-400 uppercase mb-2">
            MEET GRAHAM
          </h2>
          <p className="text-gray-300">
            Graham Salmons, FDA, MRAeS, is the founder of Flightpath Mentoring. He held senior leadership
            roles at Canon, Lexmark, 3Com, and Cisco Systems before changing careers to follow his passion for
            aviation. With over 11,500 hours of commercial flying experience, Graham is a captain, type rating
            instructor, check airman, and mentor. He also holds a first-class degree in Aviation Leadership and
            Management and is a member of the Royal Aeronautical Society.
          </p>
        </div>
        <div className="flex-shrink-0">
          <img
            src="/GS-Flying.jpg"
            alt="Graham Salmons flying"
            className="rounded-lg shadow-md w-64 object-cover"
          />
        </div>
      </section>

      <section>
        <h2 className="text-xl font-semibold text-amber-400 uppercase mb-2">
          ABOUT MENTORING
        </h2>
        <p className="text-gray-300">
          Mentoring is a guided, reflective process. Through active questioning and discussion, mentees explore
          their assumptions, emotional responses, and decision-making. The process is confidential (with the
          exception of safeguarding requirements) and highly individualised, allowing each mentee to learn in
          their own context.
        </p>
        <p className="text-gray-300 mt-4">
          For aspiring pilots, mentoring includes industry insight from experienced professionals, helping them
          make informed decisions about their career path. For corporate mentees, it provides a safe space to
          explore real challenges and practice leadership thinking in real time.
        </p>
      </section>

      {/* PARTNERS */}
      {/* PARTNERS */}
<section id="partners">
  <h2 className="text-xl font-semibold text-amber-400 uppercase mb-4">
    OUR PARTNERS
  </h2>
        {/* Simon Burnham */}
        <div className="mt-6 flex flex-col md:flex-row gap-6 items-start">
  <img
    src="/images/simon-burham.jpeg"
    alt="Simon Burnham"
    className="rounded-lg shadow-md w-full md:w-64 object-cover"
  />

  <div>
    <h3 className="text-lg font-bold text-amber-400 uppercase mb-3">
      Simon Burnham
    </h3>
    <p className="text-gray-300">
      Simon Burnham is an aviation instructor, mentor, and former Chief Theoretical Knowledge Instructor
      with a passion for making complex ATPL theory clear, practical, and accessible. 
      <br />
      Simon specialises in 1-to-1 and small-group tuition tailored to the individual — 
      because no two students learn the same way. A strong advocate for modular training and
      inclusive education, he is particularly committed to supporting neurodivergent student pilots, 
      drawing on both professional experience and personal understanding. Above all, Simon believes great
      aviation training should be supportive, honest, and rooted in real-world flying.
      <br />
      Simon supports mentees who are tackling demanding theoretical knowledge subjects and want structured
      guidance and confidence.
    </p>
    <p className="text-gray-300">
  Simon Burnham is an aviation instructor, mentor, and former Chief Theoretical Knowledge Instructor
  with a passion for making complex ATPL theory clear, practical, and accessible. Simon supports mentees
  who are tackling demanding theoretical knowledge subjects and want structured guidance and confidence.
</p>
<a
  href="https://www.facebook.com/profile.php?id=61585003842162&mibextid=wwXIfr&rdid=gZbQn94ZP9xcuJSw&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F16q4U4NjUo%2F%3Fmibextid%3DwwXIfr" // replace with correct URL
  target="_blank"
  rel="noopener noreferrer"
  className="inline-block mt-3 text-amber-400 underline hover:text-amber-300 transition"
>
  Visit Simon Burnham’s website →
</a>
  </div>
</div>
        {/* Pterinos */}
        <div className="mt-10 flex flex-col md:flex-row gap-6 items-start">
  <img
    src="/images/pterinos.jpeg"
    alt="Pterinos logo"
    className="rounded-lg shadow-md w-full md:w-64 object-cover"
  />

  <div>
    <h3 className="text-lg font-bold text-amber-400 uppercase mb-3">
      Pterinos Ltd
    </h3>
    <p className="text-gray-300">
      Pterinos is a specialist aviation consultancy with decades of experience working with large organisations
      in analysis, operations, optimisation, compliance, regulation, and training. Corporate customers can
      benefit from Pterinos' involvement in tailored organisational development and training plans.
    </p>
    <a
  href="https://www.pterinos.com" // replace with correct URL
  target="_blank"
  rel="noopener noreferrer"
  className="inline-block mt-3 text-amber-400 underline hover:text-amber-300 transition"
>
  Visit Pterinos →
</a>
  </div>
</div>
      </section>
    </main>
  );
}
